import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers, withStateHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { adminActions } from '../../../../state/modules/admin';
import { downloadBlobStreamFile, getBlobStream, getCsvStream, writeDataToCsvStream } from '../../../../utils';
import { LoadingButton } from '../../../components';

/**
 * Default take value for querying the content rating report from server.
 */
const defaultTake = 32;

const ContentRatingDashboard = ({
  toggleGeneratingContentRatingReport,
  fetchingProgress,
  isGeneratingContentRatingReport,
}) => (
    <div className='base-layout'>
      <section className='layout--header'>
        <Grid>
          <Row className='button-gutter'>
            <Col xs={12}>
              <h1>Content Rating</h1>
            </Col>
          </Row>
        </Grid>
      </section>
      <section id='section--admin-content' className='layout--section'>
      <Grid>
        <Row className='no-gutter sectionHeader'>
          {
            isGeneratingContentRatingReport ? `Estimation Progress ... ${(100 * fetchingProgress).toFixed(0)}%` : null
          }
          <LoadingButton loading={isGeneratingContentRatingReport} onClick={toggleGeneratingContentRatingReport} text={`Generate content rating report`} />
        </Row>
      </Grid>
      </section>
    </div>
  )

const mapStateToProps = ({ admin, cpdCategorys }) => ({
  contentRatingReport: admin.contentRatingReport,
  isFetchingReport: admin.isFetchingReport,
  cpdCategorys: cpdCategorys.cpdCategorys,
});

const mapDispatchToProps = (dispatch) => ({
  getContentRatingReport: bindActionCreators(adminActions.admin.getContentRatingReport, dispatch),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers(
    {
      isGeneratingContentRatingReport: false,
      fetchingProgress: 0,
    },
    {
      toggleGeneratingContentRatingReport: ({ isGeneratingContentRatingReport }) => () => ({
        isGeneratingContentRatingReport: !isGeneratingContentRatingReport,
      }),
      setFetchingProgress: () => (nextProgress) => ({
        fetchingProgress: nextProgress > 1 ? 1 : nextProgress,
      })
    }
  ),
  withHandlers({
    exportCsv: ({ cpdCategorys }) => (contentRating) => {
      const columns = [
        'user first name',
        'user last name',
        'email address',
        'business',
        'user type',
        'industry',
        'feedback date',
        'content title',
        'cpd categories',
        'publisher',
        'smile score',
        'written feedback',
      ];

      const rows = contentRating.map((rating, index) => {
        return [
          rating.user.firstName,
          rating.user.lastName,
          rating.user.email,
          rating.userBusiness.map((business) => business.name).join('/'),
          rating.userRoles.map((role) => role.role).join('/'),
          rating.userIndustry.map((industry) => industry.name).join('/'),
          rating.metaData.dateCreated,
          rating.content.title,
          rating.content.cpdCategorys.map(
            (contentCategory) => 
              cpdCategorys.find((category) => contentCategory.cpdCategoryId === category.id).name
          ).join(', '),
          rating.publisher.name,
          rating.rating,
          rating.reason,
        ];
      });

      downloadBlobStreamFile(writeDataToCsvStream(getCsvStream({
        header: true,
        columns,
      }), rows).pipe(getBlobStream()), 'content-rating-report.csv')
    }
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      const {
        isFetchingReport,
        isGeneratingContentRatingReport,
        contentRatingReport,
        getContentRatingReport,
        toggleGeneratingContentRatingReport,
        setFetchingProgress,
        exportCsv,
      } = this.props

      if (isGeneratingContentRatingReport && !isFetchingReport) {
        const currentFetchProgress = contentRatingReport ? contentRatingReport.contentRating.length / contentRatingReport.total : 0;
        setFetchingProgress(currentFetchProgress);
        const fetchingCompleted = currentFetchProgress >= 1;

        if (!fetchingCompleted) {
          const filter = {
            skip: contentRatingReport ? contentRatingReport.contentRating.length : 0,
            take: defaultTake,
          }
          getContentRatingReport(filter)
        } else {
          exportCsv(contentRatingReport.contentRating);
          toggleGeneratingContentRatingReport();
        }
      }
    }
  })
)(ContentRatingDashboard);



// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/content-portal/content-rating.js